import { DispatchFilterMap } from '../DataGrid/Dispatch/types';

/**
 * Maps a Filter to the correlating Dispatch Leg Fields since they are not 1:1.
 * Used to populate a dropdown for users to build queries. These are saved to the database, do not change existing names.
 */
export const dispatchFilterMaps: DispatchFilterMap = {
  AvailableDate: {
    displayName: 'Available Date',
    fieldType: 'date',
    // fullAvailDate is the raw ISO string off the API; fullAvailableDate is the ParsedDate carrying the unix value
    fields: ['fullAvailableDate'],
    fieldProperty: 'unix'
  },
  Chassis: {
    displayName: 'Chassis',
    fieldType: 'string',
    fields: ['chassisId'],
    fieldProperty: 'raw'
  },
  Customer: {
    displayName: 'Customer',
    fieldType: 'string',
    fields: ['custId']
  },
  Cutoff: {
    displayName: 'Cutoff',
    fieldType: 'date',
    fields: ['cutoffDate'],
    fieldProperty: 'unix'
  },
  Delivery: {
    displayName: 'Delivery',
    fieldType: 'string',
    fields: ['delvId']
  },
  Driver: {
    displayName: 'Driver',
    // drvId is a string, so the comparison operators cannot be applied to it
    fieldType: 'string',
    fields: ['drvId']
  },
  DriverPriority: {
    displayName: 'Driver Priority',
    fieldType: 'number',
    fields: ['drvPriority'],
    isDisabledAdding: true
  },
  Hazmat: {
    displayName: 'Hazmat Loads',
    fieldType: 'boolean',
    fields: ['isHazmat']
  },
  JobCategory: {
    displayName: 'Job Category',
    fieldType: 'string',
    fields: ['jobCat']
  },
  LastFreeDay: {
    displayName: 'Last Free Day',
    fieldType: 'date',
    fields: ['lastFreeDayDate'],
    fieldProperty: 'unix'
  },
  Leg: {
    displayName: 'Leg #',
    fieldType: 'number',
    fields: ['legNo']
  },
  LegPriority: {
    displayName: 'Leg Priority',
    fieldType: 'number',
    fields: ['legPriority']
  },
  LegStatus: {
    displayName: 'Leg Status',
    fieldType: 'string',
    fields: ['legStatus']
  },
  LegType: {
    displayName: 'Leg Type',
    fieldType: 'string',
    fields: ['legType']
  },
  PickupDate: {
    displayName: 'Pickup Date',
    fieldType: 'date',
    fields: ['pickupDate'],
    fieldProperty: 'unix'
  },
  Pickup: {
    displayName: 'Pickup',
    fieldType: 'string',
    fields: ['puId']
  },
  PickupDelivery: {
    displayName: 'Pickup or Delivery Location',
    fieldType: 'string',
    fields: ['puId', 'delvId']
  },
  ScheduledDeliveryDate: {
    displayName: 'Scheduled Delivery Date',
    fieldType: 'date',
    fields: ['scheduledDeliveryDateFrom'],
    fieldProperty: 'unix'
  },
  ScheduledPickupDate: {
    displayName: 'Scheduled Pickup Date',
    fieldType: 'date',
    fields: ['scheduledPickupDateFrom'],
    fieldProperty: 'unix'
  },
  ScheduledPickupDeliveryDate: {
    displayName: 'Scheduled Pickup or Delivery Date',
    fieldType: 'date',
    fields: ['scheduledDeliveryDateFrom', 'scheduledPickupDateFrom'],
    fieldProperty: 'unix'
  },
  TransportType: {
    displayName: 'Transport Type',
    fieldType: 'string',
    fields: ['jobCategoryTransportationType']
  }
  // User: {
  // 	displayName: 'User',
  // 	fieldType: 'string',
  // 	fields: ['createdUsrCode']
  // }
};
